import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { TERMS_CONDITIONS } from '../data/legalContent';
export function TermsConditionsPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-629">
      {/* Header */}
      <div className="bg-white border-b border-gray-200" data-id="element-630">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-631">
          <a href="/" className="inline-flex items-center text-purple-600 hover:text-purple-700 font-medium transition-colors" data-id="element-632">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-633" />
            Back to Home
          </a>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-634">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-635">
          <h1 className="text-4xl font-bold text-gray-900 mb-8" data-id="element-636">
            Terms & Conditions
          </h1>

          <div className="prose prose-sm max-w-none" data-id="element-637">
            {TERMS_CONDITIONS.split('\n\n').map((paragraph, index) => {
            const isHeading = paragraph.match(/^[A-Z\s]+$/) || paragraph.match(/^\d+\.\s+[A-Z]/);
            const isSubheading = paragraph.match(/^[A-Z][a-z\s]+:$/);
            if (paragraph === 'Terms & Conditions') {
              return null; // Skip duplicate title
            }
            if (paragraph.startsWith('Last Updated:')) {
              return <p key={index} className="text-sm text-gray-500 mb-8" data-id="element-638">
                    {paragraph}
                  </p>;
            }
            if (isHeading) {
              return <h2 key={index} className="text-xl font-bold text-gray-900 mt-8 mb-4" data-id="element-639">
                    {paragraph}
                  </h2>;
            }
            if (isSubheading) {
              return <h3 key={index} className="text-lg font-semibold text-gray-800 mt-6 mb-3" data-id="element-640">
                    {paragraph}
                  </h3>;
            }
            return <p key={index} className="text-gray-700 leading-relaxed mb-4" data-id="element-641">
                  {paragraph}
                </p>;
          })}
          </div>
        </div>
      </div>
    </div>;
}